export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-euro-b85a57b2b1f8b5b62271283f6cdd2be8.svg";